export const Groups = {
  Supplier: 'supplier',
  Merchant: 'merchant',
  Client: 'client',
} as const

export type GroupsType = (typeof Groups)[keyof typeof Groups]
